<script setup lang="ts">
import { onBeforeUnmount, watch } from "vue";
import { useIdle } from "@vueuse/core";
import { APP_IDLE_RELOAD_TIMEOUT } from "@/consts";
import { confirmation } from "@/stories/displays/Confirmation/Confirmation.vue";

const {
  idle,
  start: startIdle,
  stop: stopIdle,
} = useIdle(APP_IDLE_RELOAD_TIMEOUT);

watch(idle, (isIdle) => {
  if (isIdle) {
    stopIdle();
    confirmation({
      variant: "primary",
      custom: {
        title: "templates.confirm_inactive_user.title",
        description: "templates.confirm_inactive_user.description",
        confirmText: "templates.confirm_inactive_user.refresh",
        cancelText: "templates.confirm_inactive_user.continue",
      },
      onConfirm: () => window.location.reload(),
      onCancel: startIdle,
    });
  }
});

onBeforeUnmount(stopIdle);
</script>

<template></template>
